module.exports = __webpack_public_path__ + "img/emoticon-nps-7-off.b7748e93.svg";